import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { TestRatingFormTypes } from '@/store/types/testRatingFormTypes';

const testRatingFormData: TestRatingFormTypes = {
    email: '',
    msg: '',
    rating: 0,
    test_id: 1,
    attempt_key: '',
};


const formSlice = createFormSlice('testRatingForm', testRatingFormData);

const combinedSlice = createSlice({
    name: 'testRatingForm',
    initialState: formSlice.getInitialState(),
    reducers: {
        setRatingFormEmail(state, action) {
            state.data.email = action.payload;
        },
        ...formSlice.caseReducers,
    },
});

export const {
    resetSuccessMessage,
    setError,
    setRatingFormEmail
} = combinedSlice.actions;

export const sendTestRating = (data: TestRatingFormTypes) => sendForm(combinedSlice, API_ENDPOINTS.ratingForm, 'validation.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as testRatingFormSlice };
